import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LoginComponent } from "./login/login.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { AddPatientsComponent } from "./add-patients/add-patients.component";

import { PassGuardService } from "./auth/pass-guard.service";

import { AdminDashboardComponent } from "./admin-dashboard/admin-dashboard.component";
import { AdminGuardService } from "./auth/admin-guard.service";
import { MHProffGuardService } from "./auth/mhProff-guard.service";
import { AuthGuard } from "./auth/auth.guard";

import { DistDashboardComponent } from "./dist-dashboard/dist-dashboard.component";

import { DistPatDataOverviewComponent } from "./dist-pat-data-overview/dist-pat-data-overview.component";
import { LoginGuard } from "./login-guard.service";



const routes: Routes = [
  { path: "login", component: LoginComponent, canActivate: [LoginGuard] },
  {
    path: "home",
    component: DashboardComponent,
    canActivate: [AuthGuard, PassGuardService, MHProffGuardService],
  },

  // { path: 'addUser', component: AddUsersComponent, canActivate: [AuthGuard, PassGuardService, AdminGuardService] },

  // { path: 'manageUsers', component: ManageUsersComponent, canActivate: [AuthGuard, PassGuardService, AdminGuardService] },

  // { path: 'adminDashboard', component: AdminDashboardComponent, canActivate: [AuthGuard, PassGuardService, AdminGuardService] },
  { path: "adminDashboard", component: AdminDashboardComponent },
  { path: "distDashboard", component: DistDashboardComponent },
  { path: "dashboard", component: DashboardComponent },
  { path: "addPatientData", component: AddPatientsComponent },
  { path: "distPatDataOverview", component: DistPatDataOverviewComponent },

 

  { path: "", redirectTo: "/login", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}

export const routingComponents = [
  LoginComponent,
  DashboardComponent,

  AdminDashboardComponent,

];
